import {AbstractRepository} from './AbstractRepository'
import 'core-js/es6/array';

export class LinkRepository extends AbstractRepository {
    link;

    constructor() {
        super();
        this.link = this.table('link');
    }

    findByBox(box) {
        return new Promise(resolve => {
            this.transaction('rw', this.link, () => {
                this.link = this.link.where('box').equals(parseInt(box)).toArray();
                resolve(this.link);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    findById(id) {
        return new Promise(resolve => {
            this.transaction('rw', this.link, () => {
                this.link = this.link.where("id").equals(parseInt(id)).toArray();
                resolve(this.link);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    update(link) {
        return new Promise(resolve => {
            this.transaction('rw', this.link, () => {
                resolve(this.link.update(link.id, {
                    color: link.color,
                    title: link.title,
                    href: link.href
                    }
                ));
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    add(title,color,href,box) {
        return new Promise(resolve => {
            this.transaction('rw', this.link, async () => {
                let id = await this.link.add(
                    {
                        color: color,
                        title: title,
                        href: href,
                        box: box
                    }
                );
                resolve({
                    id: id,
                    color: color,
                    title: title,
                    href: href,
                    box: box
                });
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    remove(id) {
        this.transaction('rw', this.link, async() => {
            await this.link.where("id").equals(id).delete();
        }).catch(e => {
            alert(e.stack || e);
        });
    }
}
